import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    resources: {
      en: {
        translation: {
          // Navigation
          nav: {
            home: "Home",
            aiLab: "AI Lab",
            aboutUs: "About Us",
            faq: "FAQ",
            contact: "Contact"
          },
          // Main Page
          mainPage: {
            hero: {
              title: "Build, Automate, and Scale with AI",
              description: "Our Platform will empower businesses, developers, and creators with cutting-edge AI tools to automate workflows, execute tasks, and build AI-powered bots—without complex coding."
            },
            aiLab: {
              title: "Zenit AI Lab Platform",
              comingSoon: "Zenit AI Lab is coming soon!",
              description: "The platform will be an advanced solution for building, executing, and managing AI-driven workflows. Designed for businesses and developers, the platform will enable automation of complex processes, optimize decision-making, and integrated with internal and external systems."
            },
            resources: {
              title: "Zenit AI Lab Resources",
              dataset: {
                title: "AI Workflows",
                description: "Automate processes with AI-driven decision-making, cloud computing, and seamless integrations to enhance efficiency and streamline operations."
              },
              models: {
                title: "Virtual Assistants",
                description: "AI-powered assistants automate customer interactions, provide intelligent responses, and optimize communication across multiple channels efficiently."
              },
              endpoints: {
                title: "Task Bots",
                description: "Automated agents execute repetitive tasks, process data, and enhance productivity by reducing manual workload and improving operational efficiency."
              }
            },
            useCases: {
              title: "AI Workflows",
              textToText: {
                title: "AI Models",
                description: "Use AI to process data, generate insights, and perform complex tasks."
              },
              textToImage: {
                title: "Databases",
                description: "Connect your databases to access, store, and manage information within workflows."
              },
              imageClassification: {
                title: "Integrations",
                description: "Integrated with apps like email and social media to enhance automation. "
              }
            },
            zenitCoins: {
              tagline: "Unlock Seamless AI Development and Deployment with",
              highlightText: "Zenit AI Lab",
              title: "Zenit Coins",
              description: "Zenit Coins will allow you to access and manage our comprehensive suite of AI tools and services.",
              ctaTitle: "Interested in early access?",
              ctaDescription: " 📩 Contact us to join the waitlist",
              buttonText: "Contact Us"
            },
            // Sección de AI Specialized
            aiSpecialized: {
              title: "Other services: Specialized AI Application Development",
              paragraph1: "We offer a premier service for creating custom AI applications designed to fit your individual needs. When standard AI Lab can’t deliver, we step in with bespoke solutions crafted to your specifications.",
              paragraph2: "If you require a specialized AI solution, we’re here to deliver. Our custom approach ensures that you get a product that fits seamlessly with your vision and objectives.",
              buttonText: "Reach out to discuss your project"
            }
          },

          // Main Page

          carousel: {
  sectionTitle: "With Zenit AI Lab Platform, you will be able to:",
  useCasesHeader: "Use Cases",
  drag: "Drag",
  slides: {
    workflows: {
      title: "AI Workflows",
      description:
        "The core of automation. AI Workflows let users create modular, scalable flows, connecting nodes to execute tasks autonomously. Supports databases and external services.",
      imageAlt: "AI Workflows",
      useCases: {
        customerService: {
          title: "Customer Service Automation",
          description: "Chatbots and assistants execute workflows in real time.",
        },
        documentGeneration: {
          title: "Document Generation & Analysis",
          description: "Automate reports, summaries, and information processing.",
        },
        bringIdeas: {
          title: "Bring Your Ideas",
          description:
            "Turn everyday tasks into smart automations—accelerate your journey with Zenit AI.",
        },
      },
    },
    bots: {
      title: "Bot Service",
      description:
        "Zenit AI Bots are event-driven agents that trigger workflows automatically—ideal for repetitive tasks such as invoice validation, document analysis, and system integrations.",
      imageAlt: "Task Bot",
      useCases: {
        smartInbox: {
          title: "Smart Inbox Automation",
          description:
            "Process incoming emails automatically and trigger the right workflow instantly.",
        },
        scheduled: {
          title: "Scheduled Automations",
          description:
            "Run workflows on custom schedules—daily reports, weekly tasks, or recurring jobs.",
        },
        webhook: {
          title: "Webhook-Driven Operations",
          description:
            "Connect external systems via webhooks to run workflows in real time.",
        },
      },
    },
    assistants: {
      title: "Virtual Assistants",
      description:
        "Virtual Assistants understand queries and execute AI Workflows to solve tasks, answer questions, or connect with your tools.",
      imageAlt: "Virtual Assistant",
      useCases: {
        instantQA: {
          title: "Instant Q&A Automation",
          description:
            "Answer user questions in real time by triggering AI workflows that pull data or generate insights.",
        },
        onDemandReports: {
          title: "On-Demand Report Generation",
          description:
            "Users request reports via chat—your assistant runs the workflow and delivers the result.",
        },
        taskExecution: {
          title: "Task Execution by Request",
          description:
            "From sending emails to updating databases, assistants launch the right workflow on demand.",
        },
      },
    },
  },
},
aiLabFeatures: {
  noCode: "No-Code & Developer-Friendly",
  secure: "Scalable & Secure",
  deploy: "Deploy your solutions with ease",
},
aiLab: {
  /* añade solo esta línea nueva dentro de aiLab */
  shortDescription:
    "will enable you to automate complex processes with AI-powered workflows, task bots, and virtual assistants. Designed for speed and simplicity, it will turn ideas into scalable automations—without technical barriers.",
},
waitlist: {
  title: "Take your automation to the next level",
  placeholder: "Enter your email address...",
  button: "JOIN THE WAITLIST",
},



apiKeys: {
  title: "API Keys",
  pageDesc: "Manage account settings for every service you build.",
  noKeys: "No keys added yet",
  addKey: "Add key",
  addKeyFor: "Add API key for {{provider}}",
  placeholder: "Paste your key here…",
  descPlaceholder: "Briefly describe what this key is for",
  cancel: "Cancel",
  save: "Save",
  editKeyFor: "Edit API key for {{provider}}",
  confirmDelete: "Delete this key?",
  pageDesc: "Manage and store your API keys for the services powering your application.",
  delete: "Delete"
},

  providers: {
    blackForest: "Black Forest Labs",
    openAI: "Open AI",
    together: "Together"
  },


    dbConnections: {
    title: "DB Connections",
    pageDesc:
      "Here you can view, test, and manage all your database connections. Create new ones or delete those you no longer need.",
    cardDesc: "Fill in the fields below to establish a new connection.",
    newConnection: "New Connection",
    displayName: "Display name",
    engine: "Engine",
    sqliteFile: "SQLite file",
    host: "Host / IP",
    port: "Port",
    database: "Database",
    serviceName: "Service Name / SID",
    user: "User",
    password: "Password",
    testConnection: "Test connection",
    save: "Save",
    ok: "OK",
    fileLabel: "File:",
    hostLabel: "Host:",
    dbLabel: "DB:",
    confirmTitle: "Are you sure?",
    confirmText: "This will permanently delete the connection.",
    cancel: "Cancel",
    delete: "Delete",
    toastSaved: "✅ Connection saved!",
    toastDeleted: "🗑️ Connection deleted!",
    noName: "(no name)",
  },

// Settings Page
settings: {
  title: "Settings",
  description: "Adjust your preferences to manage language settings, privacy options, and account security.",
  privacy: {
    title: "Privacy & Security",

    // Public/Private
    public: "Public",
    private: "Private",
    save: "Save",
    savedMessage: "Changes saved successfully!",

    // Account Visibility
    accountVisibilityTitle: "Account Visibility",
    accountVisibilityDescription: "Who can see your profile and activity?",

    // Store data
    storeDataTitle: "Store prompts and model responses and allow them to be used for product improvements.",
    storeDataDescription: "You can delete your data anytime. We don't share your data with any third parties.",

    // Allow model training
    allowModelTitle: "Allow my data to be used for training models released by Zenit AI Lab and partners.",
    allowModelDescription: "We don't share your data with any third parties.",

    // Delete data/Account section
    deleteDataTitle: "Delete Account",
    deleteDataDescription: "This action will permanently delete your account and all associated data. This cannot be undone.",
    deleteDataButton: "Delete Account",
    
    // Warning stage 1
    warningTitle: "Warning: Account Deletion",
    warningDescription: "You are about to start the account deletion process. All your data, including profile information, history, and saved content will be permanently removed. This action cannot be undone.",
    cancel: "Cancel",
    proceed: "Proceed",
    
    // Warning stage 2 (final)
    finalWarningTitle: "Final Warning: Confirm Account Deletion",
    finalWarningDescription: "Once confirmed, your account and all associated data will be permanently deleted. This cannot be reversed or recovered.",
    typeToConfirm: "Type {{text}} to confirm deletion",
    confirmDelete: "Delete My Account",
    deleting: "Deleting...",
  },
  password: {
    title: "Change password",
    requirements: "Your password must be at least 8 characters and should include a combination of numbers, letters and special characters (!@#$%).",
    currentPassword: "Current password",
    newPassword: "New password",
    retypePassword: "Re-type new password",
    forgot: "Forgot your password?",
    change: "Change password",
    savedMessage: "Password changed successfully!"
  },
  language: {
    title: "Language",
    preferred: "Preferred Language Settings",
    save: "Save",
    savedMessage: "Language updated successfully!"
  }
},
general: {
  yes: "Yes",
  no: "No"
},


            aboutUs: {
            mission: {
              title: "MISSION",
              text: "Our mission is to deliver accessible, simple, and innovative artificial intelligence, enabling individuals and businesses to use AI without technical barriers. We create tools that automate and optimize processes, making AI a practical and efficient solution for everyday needs."
            },
            vision: {
              title: "VISION",
              text: "Our vision is to become the regional leader in accessible and easy-to-use AI, empowering people and businesses to transform their operations with innovative technology. We see a future where AI is an everyday tool that fosters growth and digital evolution without complexity."
            },
"roadmap": {
      "title": "ROAD MAP",
      "pressTheCircle": "Press the circle to discover our key objectives",
      "quarters": {
        "Q1": "Q1",
        "Q2": "Q2",
        "Q3": "Q3",
        "Q4": "Q4"
      },
      "year": "2025",
      "modalContent": {
        "Q1": [
          "●  Validate the current products offer with key users, ensuring that the solutions address real problems within the target market.",
          "●  Refine the product offering for Zenit AI Platform.",
          "●  Consolidate web app"
        ],
        "Q2": [
          "●  Develop the first version of Zenit AI Platform and strengthen the technological foundation.",
          "●  Engage in funding rounds."
        ],
        "Q3": [
          "●  Launch the first version of the application in production.",
          "●  Build the brand’s presence on social media.",
          "●  Implement a sales strategy."
        ],
        "Q4": [
          "●  Prepare the startup for scaling.",
          "●  Roll out new features in production, like virtual assistants and task bots.",
          "●  Explore new markets."
        ]
      }
    },
            meetTheTeam: "Meet the Team",
          
            roles: {
              backend: "Security & Backend Engineer",
              frontend: "Front-end Engineer",
              aiEngineer: "CTO & AI Engineer",
              uiUx: "UI | UX Designer & Illustrator",
              projectManager: "CEO",
              machineLearning: "Machine Learning Engineer"
            }
          },
          nav: {
            home: "Home",
            aiLab: "Products",
            aboutUs: "About Us",
            faq: "FAQ",
            contact: "Contact"
          },
          header: {
            signUp: "Sign Up",
            logIn: "Log In",
            viewProfile: "View Profile",
            logOut: "Log Out",
            logoAlt: "Logo",
            logoTextAlt: "Logo Text",
            userAlt: "User",
            avatarAlt: "User Avatar",
            launchApp: "Launch App"
          },
          faq: {
            header: {
              title: "Frequently Asked Questions",
              subtitle: "Find answers to common questions about Zenit AI",
              backButton: "← Back"
            },
            categories: {
              about: {
                title: "About Zenit AI Lab",
                questions: [
                  {
                    q: "What is Zenit AI Lab?",
                    a: "Zenit AI Lab is a company specializing in artificial intelligence, dedicated to making AI accessible and practical for individuals and businesses. Our goal is to provide tools and solutions that allow users to easily customize and implement AI to meet their specific needs, without the usual complexity or long development times."
                  },
                  {
                    q: "What is the vision of Zenit AI Lab?",
                    a: "Our vision is to become the regional leader in accessible and easy-to-use AI, empowering people and businesses to transform their operations with innovative technology. We see a future where AI is an everyday tool that fosters growth and digital evolution without complexity."
                  },
                  {
                    q: "What is the mission of Zenit AI Lab?",
                    a: "Our mission is to deliver accessible, simple, and innovative artificial intelligence, enabling individuals and businesses to use AI without technical barriers. We create tools that automate and optimize processes, making AI a practical and efficient solution for everyday needs."
                  },
                  {
                    q: "What are the core values of Zenit AI Lab?",
                    a: "At Zenit AI Lab, we prioritize accessibility, simplicity, and innovation. We are committed to ethical AI development, ensuring that our tools are both impactful and responsible while empowering users to harness technology effectively."
                  }
                ]
              },
              offerings: {
                title: "Offerings",
                questions: [
                  {
                    q: "What does Zenit AI Lab currently offer?",
                    a: "Zenit AI Lab currently offers Custom AI Solutions, creating personalized artificial intelligence systems tailored to meet the specific needs of individuals and businesses. These solutions are developed using advanced AI models and client-provided data."
                  },
                  {
                    q: "What is the Zenit AI Lab Platform?",
                    a: "The Zenit AI Lab Platform is an upcoming platform designed to simplify the creation, deployment, and management of AI applications. It will provide tools for customization, integration, and monitoring, making AI accessible for users without requiring deep technical expertise."
                  },
                  {
                    q: "What features will the Zenit AI Lab Platform include?",
                    a: "The platform will consist of three main features: Chatbots for customer support and sales, AI Workflows for streamlining processes, and Social Manager Bot for automating social media management tasks."
                  },
                  {
                    q: "When will the Zenit AI Lab Platform be available?",
                    a: "The Zenit AI Lab Platform is currently under development and is expected to launch by the end of 2025."
                  }
                ]
              },
              security: {
                title: "Security",
                questions: [
                  {
                    q: "How will Zenit AI Lab Platform address security concerns?",
                    a: "The Zenit AI Lab Platform prioritizes security through: Secure Cloud Storage with advanced encryption, User-Controlled Data Management, and strict Privacy Compliance standards."
                  }
                ]
              },
              support: {
                title: "Support",
                questions: [
                  {
                    q: "Will Zenit AI Lab Platform provide support for its users?",
                    a: "Yes, comprehensive support includes detailed documentation and dedicated Discord servers for ticket submission and support. Our team provides prompt issue resolution and answers to questions."
                  }
                ]
              },
              pricing: {
                title: "Pricing",
                questions: [
                  {
                    q: "How will Zenit AI Lab Platform pricing work?",
                    a: "We offer three subscription plans: Free Plan (limited features), Developer Plan (for individuals/small teams), and Enterprise Plan (for larger organizations). Additional purchasing options available for specific needs."
                  }
                ]
              }
            }
          },
          contact: {
            title: "Want To Contact With Us?",
            subtitle: "Please enter your information and we will reach you as soon as possible",
            errorFillAll: "Please fill in all fields",
            errorEmail: "Please provide a valid email address",
            errorSendFailed: "Failed to send email: ",
            errorGeneric: "An error occurred while sending the email. Please try again.",
            form: {
              labelEmail: "Email",
              labelName: "Name",
              labelMessage: "Message",
              buttonSend: "Send"
            },
            discord: {
              join: "Join our community on discord!"
            },
            submitted: {
              thankYou: "Thank you for connecting with us!",
              followUp: "We will reach you as soon as possible"
            },
            dropdown: {
              label: "Reason",
              placeholder: "Select a reason...",
              options: {
                specializedAi: "Specialized AI Solutions",
                technicalSupport: "Technical Support",
                generalPurpose: "General Purpose",
                coins: "Coins"
              }
            },
          },
          profilePage: {
            sidebar: {
              profile: "Profile",
              billing: "Billing",
              subscriptions: "Subscriptions",
              settings: "Settings",
              support: "Support",
              apiKeys: "API Keys",
              dbConnections: "DB Connections",
            },
            profileHeaderTitle: "Profile",
            profileHeaderSubtitle: "Manage and update your personal information",
            bioLabel: "Bio",
            addBioPlaceholder: "Add a bio",
            username: "Username",
            email: "Email",
            phone: "Phone",
            addPhonePlaceholder: "Add phone number",
            address: "Addresses",
            addAddressPlaceholder: "Add address",
            country: "Country",                  // <-- Nueva clave
            selectCountryPlaceholder: "Select a country", // <-- Nueva clave
            saveChanges: "Save Changes",
            saving: "Saving...",
            underConstructionMessage: "This section is under construction",
          
            avatar: {
              changeBtn: "Change",
              removeBtn: "Remove"
            },
          
            modal: {
              uploadPhotoTitle: "Upload Photo",
              generatePhotoTitle: "Generate Photo",
              uploadTab: "Upload",
              generateTab: "Generate",
              dropImageHere: "Drop the image here",
              selectFromComputer: "Select from computer",
              promptLabel: "Prompt",
              placeholderPrompt: "e.g.: Short curly hair, green eyes, and a big smile",
              generateButton: "Generate",
              generating: "Generating...",
              saving: "Saving...",
              confirmBtn: "Confirm",
              selectAnotherBtn: "Select Another",
              removeBtn: "Remove Avatar",
              changeBtn: "Change Avatar"
            }
            
          },
          billingPage: {
            sidebar: {
              profile: "Profile",
              billing: "Billing",
              subscriptions: "Subscriptions",
              settings: "Settings",
              support: "Support"
            },
            billingHeaderTitle: "Billing",
            billingHeaderSubtitle: "Manage your payment methods and invoices",
            paymentMethods: "Payment Methods",
            invoices: "Invoices",
            underConstructionMessage: "This section is under construction"
          },  
          zenitCoinsView: {
            header: {
              title: "Zenit Coins",
              subtitle: "Access your transaction history and easily add more credits to your account."
            },
            balanceCard: "Available Balance: {{count}} Zenit Coins",
            getMoreBtn: "GET MORE",
            transactions: {
              title: "Transactions",
              subtitle: "View all coin transactions during the selected period.",
              filterByMonthLabel: "Filter by month",
              selectOption: "Select an option",
              dec2024: "December 2024",
              nov2024: "November 2024",
              viewChartBtn: "View Chart",
              tableHeader: {
                date: "Date",
                description: "Description",
                debits: "Debits",
                credits: "Credits",
                balance: "Balance"
              }
            },
            chartView: {
              backBtn: "Back",
              chartTitle: "Debits vs. Balance Analysis"
            }
          },    
          subscriptionView: {
            header: {
              title: "Subscriptions",
              subtitle: "Check your current subscription and explore additional plans."
            },
            currentSubscription: {
              title: "Current Subscription",
              plan: "Free",
              price: "$0/month"
            },
            changePlan: {
              title: "Change Plan",
              plans: {
                free: {
                  name: "Free",
                  coins: "100 Zenit Coins / Month",
                  price: "$0/month",
                  button: "Current Plan"
                },
                professional: {
                  name: "Professional",
                  coins: "500 Zenit Coins / Month",
                  price: "$20/month",
                  button: "Switch Plan"
                },
                enterprise: {
                  name: "Enterprise",
                  coins: "Unlimited Zenit Coins",
                  button: "Contact Us"
                }
              }
            },
            dialog: {
              title: "Contact",
              fromLabel: "From:",
              placeholderEmail: "Enter your email",
              placeholderMessage: "Please write the details of your request, and our support team will assist you...",
              cancel: "Cancel",
              sending: "Sending...",
              send: "Send",
              sentSuccessfully: "Sent successfully",
              somethingWentWrong: "Something went wrong. Please try again later"
            }
          },   
          supportView: {
            header: {
              title: "Support",
              subtitle: "Need assistance? We are here to help you. Please fill out the form below and our support team will get back to you as soon as possible."
            },
            form: {
              fullNameLabel: "Full name",
              discordUsernameLabel: "Discord Username*",
              discordUsernamePlaceholder: "e.g. username",
              discordHelpText: "You must be a member of the Discord server to create a ticket",
              emailLabel: "Email Address",
              subjectLabel: "Subject",
              messageLabel: "Message",
              attachmentLabel: "Attachment (Optional)",
              fileUploadBtn: "File Upload",
              submitBtn: "Submit Request",
              submitting: "Submitting...",
              successMessage: "Ticket created successfully!",
              errorMessage: "Error creating ticket. Please try again."
            },
            fileAlerts: {
              fileSizeExceeded: "File size exceeds 8MB limit",
              fileTypeNotSupported: "File type not supported. Please upload images, PDF, DOC, DOCX or TXT files."
            }
          },
          footer: {
            brand: {
              labName: "ZENIT AI LAB",
              tagline: "Let's Talk",
              email: "contact@zenitailab.com"
            },
            linksSection: {
              title: "Links",
              whitepaper: "Whitepaper",
              docs: "Documentation",
              pitchDeck: "Pitch Deck"
            },
            legalSection: {
              title: "Legal",
              disclaimer: "Disclaimer",
              privacyPolicy: "Privacy Policy",
              refundPolicy: "Refund Policy",
              terms: "Terms and Conditions"
            },
            socialSection: {
              title: "Social",
              discord: "Discord",
              telegram: "Telegram",
              linkedin: "LinkedIn",
              instagram: "Instagram",
              x: "X"
            },
            copyright:
              "Copyright © {{year}} Zenit AI Lab | All rights reserved"
          },
          
        }
      },











      es: {
        translation: {
          // Navegación
          nav: {
            home: "Inicio",
            aiLab: "Productos",
            aboutUs: "Sobre Nosotros",
            faq: "Preguntas Frecuentes",
            contact: "Contacto"
          },
          // Página Principal
          mainPage: {
            hero: {
              title: "La plataforma Zenit AI Lab empodera",
              description: "A empresas, desarrolladores y creadores con herramientas de IA de vanguardia para automatizar flujos de trabajo, ejecutar tareas y crear bots impulsados por IA, sin necesidad de programación compleja."
            },
            aiLab: {
              title: "Zenit AI Platform",
              comingSoon: "¡El Zenit AI Platform Estará Disponible Pronto!",
              description: "Estamos trabajando arduamente para traerte una plataforma revolucionaria para crear conjuntos de datos personalizados, entrenar modelos de IA avanzados y desplegarlos sin esfuerzo. ¡Mantente atento al lanzamiento de la solución más innovadora de Zenit AI!"
            },
            resources: {
              title: "Recursos del Zenit AI Lab",
              dataset: {
                title: "Conjunto de Datos",
                description: "Con AI Lab puedes crear conjuntos de datos para personalizar tus modelos."
              },
              models: {
                title: "Modelos",
                description: "La plataforma Zenit te permite desplegar rápidamente modelos de IA de última generación."
              },
              endpoints: {
                title: "Puntos de Acceso",
                description: "Despliega y escala tus modelos para aplicaciones en tiempo real."
              }
            },
            useCases: {
              title: "Casos de Uso",
              textToText: {
                title: "Texto a Texto",
                description: "Crea y personaliza tus asistentes virtuales con nuestros modelos avanzados de IA de texto a texto."
              },
              textToImage: {
                title: "Texto a Imagen",
                description: "Convierte descripciones textuales en imágenes de alta calidad y eleva el poder de tus aplicaciones."
              },
              imageClassification: {
                title: "Clasificación de Imágenes",
                description: "Clasifica imágenes con precisión y eficiencia en tiempo real."
              }
            },
            zenitCoins: {
              tagline: "Desbloquea el Desarrollo y Despliegue Fluido de IA con",
              highlightText: "Zenit AI Lab",
              title: "Zenit Coins",
              description: "Los Zenit Coins te permiten acceder y gestionar sin problemas nuestra suite completa de herramientas y servicios de IA.",
              ctaTitle: "¿Listo para Abrir la Puerta a la Innovación en IA?",
              ctaDescription: "Contáctanos directamente para acceder a nuestras herramientas y servicios de IA.",
              buttonText: "¡Contáctanos Hoy para Comenzar!"
            },
            // Sección de AI Specialized
            aiSpecialized: {
              title: "Desarrollo de Aplicaciones de IA Especializadas Para Tus Necesidades Únicas",
              paragraph1: "Ofrecemos un servicio de primer nivel para la creación de aplicaciones de IA personalizadas y diseñadas para cubrir tus necesidades individuales. Cuando los laboratorios de IA estándar no son suficientes, damos un paso al frente con soluciones a medida hechas para ti.",
              paragraph2: "Si necesitas una solución de IA especializada, estamos aquí para ayudarte. Nuestro enfoque personalizado garantiza que obtengas un producto que encaje perfectamente con tu visión y objetivos.",
              buttonText: "Contáctanos para hablar de tu proyecto"
            }
          },

          carousel: {
  sectionTitle: "Con la plataforma Zenit AI Lab, podrás:",
  useCasesHeader: "Casos de uso",
  drag: "Arrastra",
  slides: {
    workflows: {
      title: "Flujos de IA",
      description:
        "El núcleo de la automatización. Los flujos de IA permiten crear procesos modulares y escalables que ejecutan tareas de forma autónoma. Compatible con bases de datos y servicios externos.",
      imageAlt: "Flujos de IA",
      useCases: {
        customerService: {
          title: "Automatización de Servicio al Cliente",
          description: "Chatbots y asistentes ejecutan flujos en tiempo real.",
        },
        documentGeneration: {
          title: "Generación y Análisis de Documentos",
          description: "Automatiza reportes, resúmenes y procesamiento de información.",
        },
        bringIdeas: {
          title: "Trae tus Ideas",
          description:
            "Convierte tus tareas diarias en automatizaciones inteligentes: acelera tu viaje con Zenit AI.",
        },
      },
    },
    bots: {
      title: "Servicio de Bots",
      description:
        "Los Bots de Zenit AI son agentes guiados por eventos que disparan flujos automáticamente—ideales para tareas repetitivas como validación de facturas, análisis de documentos e integraciones.",
      imageAlt: "Bot de Tareas",
      useCases: {
        smartInbox: {
          title: "Automatización de Bandeja de Entrada",
          description:
            "Procesa correos entrantes automáticamente y dispara el flujo adecuado al instante.",
        },
        scheduled: {
          title: "Automatizaciones Programadas",
          description:
            "Ejecuta flujos en horarios personalizados—reportes diarios, tareas semanales o procesos recurrentes.",
        },
        webhook: {
          title: "Operaciones con Webhooks",
          description:
            "Conecta sistemas externos vía webhooks para ejecutar flujos en tiempo real.",
        },
      },
    },
    assistants: {
      title: "Asistentes Virtuales",
      description:
        "Los Asistentes Virtuales entienden consultas y ejecutan Flujos de IA para resolver tareas, responder preguntas o integrarse con tus herramientas.",
      imageAlt: "Asistente Virtual",
      useCases: {
        instantQA: {
          title: "Preguntas y Respuestas al Instante",
          description:
            "Responde consultas en tiempo real disparando flujos que obtienen datos o generan insights.",
        },
        onDemandReports: {
          title: "Generación de Reportes Bajo Demanda",
          description:
            "El usuario solicita un reporte por chat—el asistente ejecuta el flujo, analiza la información y entrega el resultado.",
        },
        taskExecution: {
          title: "Ejecución de Tareas a Pedido",
          description:
            "Desde enviar emails hasta actualizar bases de datos, el asistente lanza el flujo correcto cuando lo pides.",
        },
      },
    },
  },
},
aiLabFeatures: {
  noCode: "Sin Código y para Desarrolladores",
  secure: "Escalable y Seguro",
  deploy: "Despliega tus soluciones fácilmente",
},
aiLab: {
  shortDescription:
    "te permitirá automatizar procesos complejos con flujos de trabajo impulsados por IA, bots de tareas y asistentes virtuales. Diseñada para la velocidad y la simplicidad, convierte ideas en automatizaciones escalables sin barreras técnicas.",
},
waitlist: {
  title: "Lleva tu automatización al siguiente nivel",
  placeholder: "Ingresa tu correo electrónico...",
  button: "ÚNETE A LA LISTA DE ESPERA",
},




apiKeys: {
  title: "Claves API",
  pageDesc: "Gestiona la configuración de cuentas para cada servicio que construyas.",
  noKeys: "No hay claves añadidas aún",
  addKey: "Agregar clave",
  addKeyFor: "Agregar clave API para {{provider}}",
  placeholder: "Pega tu clave aquí…",
  descPlaceholder: "Breve descripción de para qué sirve esta clave",
  cancel: "Cancelar",
  save: "Guardar",
  editKeyFor: "Editar clave API para {{provider}}",
  pageDesc: "Gestiona y almacena tus claves API para los servicios que impulsan tu aplicación."
},


  dbConnections: {
    title: "Conexiones DB",
    pageDesc:
      "Aquí puedes ver, probar y gestionar todas tus conexiones de base de datos. Crea nuevas o elimina las que ya no necesites.",
    cardDesc: "Completa los campos abajo para establecer una nueva conexión.",
    newConnection: "Nueva conexión",
    displayName: "Nombre visible",
    engine: "Motor",
    sqliteFile: "Archivo SQLite",
    host: "Host / IP",
    port: "Puerto",
    database: "Base de datos",
    serviceName: "Nombre de servicio / SID",
    user: "Usuario",
    password: "Contraseña",
    testConnection: "Probar conexión",
    save: "Guardar",
    ok: "OK",
    fileLabel: "Archivo:",
    hostLabel: "Host:",
    dbLabel: "BD:",
    confirmTitle: "¿Estás seguro?",
    confirmText: "Esto eliminará permanentemente la conexión.",
    cancel: "Cancelar",
    delete: "Eliminar",
    toastSaved: "✅ ¡Conexión guardada!",
    toastDeleted: "🗑️ ¡Conexión eliminada!",
    noName: "(sin nombre)",
  },


          // Página de Configuración
          settings: {
            title: "Configuración",
            description: "Ajusta tus preferencias para gestionar la configuración de idioma, opciones de privacidad y seguridad de la cuenta.",
            privacy: {
              title: "Privacidad y Seguridad",
          
              // Opciones públicas/privadas
              public: "Público",
              private: "Privado",
              save: "Guardar",
              savedMessage: "¡Cambios guardados exitosamente!",
          
              // Visibilidad de la cuenta
              accountVisibilityTitle: "Visibilidad de la cuenta",
              accountVisibilityDescription: "¿Quién puede ver tu perfil y tu actividad?",
          
              // Almacenar datos
              storeDataTitle: "Almacenar prompts y respuestas para usarlas en mejoras del producto.",
              storeDataDescription: "Puedes eliminar tus datos en cualquier momento. No compartimos tus datos con terceros.",
          
              // Permitir uso de datos para modelos
              allowModelTitle: "Permitir que mis datos se usen para entrenar modelos de Zenit AI Lab y socios.",
              allowModelDescription: "No compartimos tus datos con terceros.",
          
              // Eliminar datos/cuenta
              deleteDataTitle: "Eliminar Cuenta",
              deleteDataDescription: "Esta acción eliminará permanentemente tu cuenta y todos los datos asociados. Esta acción no se puede deshacer.",
              deleteDataButton: "Eliminar Cuenta",
              
              // Advertencia etapa 1
              warningTitle: "Advertencia: Eliminación de Cuenta",
              warningDescription: "Estás a punto de iniciar el proceso de eliminación de cuenta. Todos tus datos, incluyendo información de perfil, historial y contenido guardado serán eliminados permanentemente. Esta acción no se puede deshacer.",
              cancel: "Cancelar",
              proceed: "Continuar",
              
              // Advertencia etapa 2 (final)
              finalWarningTitle: "Advertencia Final: Confirmar Eliminación de Cuenta",
              finalWarningDescription: "Una vez confirmado, tu cuenta y todos los datos asociados serán eliminados permanentemente. Esta acción no se puede revertir ni recuperar.",
              typeToConfirm: "Escribe {{text}} para confirmar la eliminación",
              confirmDelete: "Eliminar Mi Cuenta",
              deleting: "Eliminando...",
            },
            password: {
              title: "Cambiar contraseña",
              requirements: "Tu contraseña debe tener al menos 6 caracteres e incluir una combinación de números, letras y caracteres especiales (!@#$%).",
              currentPassword: "Contraseña actual",
              newPassword: "Nueva contraseña",
              retypePassword: "Vuelve a escribir la nueva contraseña",
              forgot: "¿Olvidaste tu contraseña?",
              change: "Cambiar contraseña",
              savedMessage: "¡Contraseña cambiada exitosamente!"
            },
            language: {
              title: "Idioma",
              preferred: "Configuración de idioma preferido",
              save: "Guardar",
              savedMessage: "¡Idioma actualizado con éxito!"
            }
          },
          general: {
            yes: "Sí",
            no: "No"
          },
            aboutUs: {
              mission: {
                title: "MISIÓN",
                text: "Nuestra misión es democratizar la inteligencia artificial, brindando soluciones accesibles y personalizables que se adapten a cada necesidad. Buscamos un futuro donde la IA mejore la vida diaria y las operaciones de personas y empresas."
              },
              vision: {
                title: "VISIÓN",
                text: "Ser líderes regionales en la democratización de la IA, destacando por integrar tecnología avanzada con alta seguridad de datos. Visualizamos un futuro donde nuestras soluciones accesibles y seguras empoderen a personas y organizaciones para lograr un crecimiento sostenible y una evolución tecnológica constante."
              },
              roadmap: {
                title: "ROAD MAP",
                pressTheCircle: "Presiona el círculo para descubrir nuestros objetivos clave",
                quarters: {
                  Q1: "T1",
                  Q2: "T2",
                  Q3: "T3",
                  Q4: "T4"
                },
                year: "2025",
                modalContent: [
                  "Pruebas de modelo",
                  "Iteración y mejora",
                  "Preparación de la implementación"
                ]
              },
              meetTheTeam: "Conoce al Equipo",
              roles: {
                backend: "Ingeniero Back-end",
                frontend: "Ingeniero Front-end",
                aiEngineer: "Ingeniero de IA",
                uiUx: "Diseñador(a) UI | UX & Ilustrador(a)",
                projectManager: "Gerente de Proyecto"
              }
            },
            nav: {
              home: "Inicio",
              aiLab: "Productos",
              aboutUs: "Sobre Nosotros",
              faq: "Preguntas Frecuentes",
              contact: "Contacto"
            },
            header: {
              signUp: "Registrarse",
              logIn: "Iniciar Sesión",
              viewProfile: "Ver Perfil",
              logOut: "Cerrar Sesión",
              logoAlt: "Logo",
              logoTextAlt: "Texto del Logo",
              userAlt: "Usuario",
              avatarAlt: "Avatar de Usuario",
              launchApp: "Abrir Aplicación"
            },
            faq: {
              header: {
                title: "Preguntas Frecuentes",
                subtitle: "Encuentra respuestas a preguntas comunes sobre Zenit AI",
                backButton: "← Volver"
              },
              categories: {
                about: {
                  title: "Acerca de Zenit AI Lab",
                  questions: [
                    {
                      q: "¿Qué es Zenit AI Lab?",
                      a: "Zenit AI Lab es una empresa especializada en inteligencia artificial, dedicada a hacer que la IA sea accesible y práctica tanto para personas como para empresas. Nuestro objetivo es proporcionar herramientas y soluciones que permitan a los usuarios personalizar e implementar IA con facilidad para satisfacer sus necesidades específicas, sin la complejidad o los largos tiempos de desarrollo habituales."
                    },
                    {
                      q: "¿Cuál es la visión de Zenit AI Lab?",
                      a: "Nuestra visión es empoderar a las personas y empresas para que utilicen la inteligencia artificial como una herramienta que puedan personalizar e implementar fácilmente, creando un futuro donde la IA sea accesible, intuitiva y beneficiosa para todos."
                    },
                    {
                      q: "¿Cuál es la misión de Zenit AI Lab?",
                      a: "Nuestra misión es proporcionar herramientas y soluciones que simplifiquen la creación y el despliegue de la IA, permitiendo a los usuarios adaptarla a sus necesidades específicas. Buscamos derribar las barreras técnicas y de recursos, haciendo que la IA sea una solución práctica para los desafíos cotidianos."
                    },
                    {
                      q: "¿Cuáles son los valores fundamentales de Zenit AI Lab?",
                      a: "En Zenit AI Lab, priorizamos la accesibilidad, la simplicidad y la innovación. Nos comprometemos con el desarrollo ético de la IA, asegurándonos de que nuestras herramientas sean efectivas y responsables, a la vez que empoderamos a los usuarios para aprovechar la tecnología de manera óptima."
                    }
                  ]
                },
                offerings: {
                  title: "Servicios",
                  questions: [
                    {
                      q: "¿Qué ofrece actualmente Zenit AI Lab?",
                      a: "Zenit AI Lab ofrece actualmente Soluciones de IA Personalizadas, creando sistemas de inteligencia artificial diseñados para satisfacer las necesidades específicas de personas y empresas. Estas soluciones se desarrollan usando modelos de IA avanzados y datos proporcionados por el cliente."
                    },
                    {
                      q: "¿Qué es la Plataforma Zenit AI Lab?",
                      a: "La Plataforma Zenit AI Lab es una futura plataforma diseñada para simplificar la creación, el despliegue y la gestión de aplicaciones de IA. Ofrecerá herramientas para la personalización, la integración y el monitoreo, facilitando el acceso a la IA sin requerir conocimientos técnicos profundos."
                    },
                    {
                      q: "¿Qué funciones incluirá la Plataforma Zenit AI Lab?",
                      a: "La plataforma constará de tres funciones principales: Chatbots para soporte al cliente y ventas, Flujos de Trabajo de IA para optimizar procesos y Social Manager Bot para automatizar tareas de gestión de redes sociales."
                    },
                    {
                      q: "¿Cuándo estará disponible la Plataforma Zenit AI Lab?",
                      a: "Actualmente, la Plataforma Zenit AI Lab se encuentra en desarrollo y se espera su lanzamiento para finales de 2025."
                    }
                  ]
                },
                security: {
                  title: "Seguridad",
                  questions: [
                    {
                      q: "¿Cómo abordará la Plataforma Zenit AI Lab las preocupaciones de seguridad?",
                      a: "La Plataforma Zenit AI Lab prioriza la seguridad mediante: Almacenamiento en la Nube Seguro con cifrado avanzado, Gestión de Datos Controlada por el Usuario y estrictos estándares de Cumplimiento de Privacidad."
                    }
                  ]
                },
                support: {
                  title: "Soporte",
                  questions: [
                    {
                      q: "¿La Plataforma Zenit AI Lab ofrecerá soporte a sus usuarios?",
                      a: "Sí, se brindará soporte integral que incluye documentación detallada y servidores dedicados de Discord para la creación de tickets y la asistencia. Nuestro equipo proporciona soluciones rápidas a los problemas y atiende preguntas."
                    }
                  ]
                },
                pricing: {
                  title: "Precios",
                  questions: [
                    {
                      q: "¿Cómo funcionará el modelo de precios de la Plataforma Zenit AI Lab?",
                      a: "Ofrecemos tres planes de suscripción: Plan Gratuito (con funciones limitadas), Plan para Desarrolladores (para individuos o equipos pequeños) y Plan Empresarial (para organizaciones más grandes). Hay opciones de compra adicionales disponibles según las necesidades específicas."
                    }
                  ]
                }
              }
            },
            contact: {
              title: "¿Quieres contactar con nosotros?",
              subtitle: "Por favor ingresa tu información y te contactaremos lo antes posible",
              errorFillAll: "Por favor, completa todos los campos",
              errorEmail: "Por favor, ingresa una dirección de correo válida",
              errorSendFailed: "Error al enviar el correo electrónico: ",
              errorGeneric: "Ocurrió un error al enviar el correo. Por favor, inténtalo de nuevo.",
              form: {
                labelEmail: "Correo Electrónico",
                labelName: "Nombre",
                labelMessage: "Mensaje",
                buttonSend: "Enviar"
              },
              discord: {
                join: "¡Únete a nuestra comunidad en Discord!"
              },
              submitted: {
                thankYou: "¡Gracias por ponerte en contacto con nosotros!",
                followUp: "Te responderemos lo antes posible"
              },
              dropdown: {
                label: "Motivo",
                placeholder: "Selecciona un motivo...",
                options: {
                  specializedAi: "Soluciones de IA Especializadas",
                  technicalSupport: "Soporte Técnico",
                  generalPurpose: "Consulta General",
                  coins: "Monedas (Coins)"
                }
              },
            },
            profilePage: {
              sidebar: {
                profile: "Perfil",
                billing: "Facturación",
                subscriptions: "Suscripciones",
                settings: "Configuración",
                support: "Soporte",
                apiKeys: "Claves API",
                dbConnections: "Conexiones DB",
              },
              profileHeaderTitle: "Perfil",
              profileHeaderSubtitle: "Gestiona y actualiza tu información personal",
              bioLabel: "Biografía",
              addBioPlaceholder: "Agrega una biografía",
              username: "Usuario",
              email: "Correo electrónico",
              phone: "Teléfono",
              addPhonePlaceholder: "Agrega tu número de teléfono",
              address: "Direcciones",
              addAddressPlaceholder: "Agrega una dirección",
              saveChanges: "Guardar cambios",
              saving: "Guardando...",
              underConstructionMessage: "Esta sección está en construcción",
            
              avatar: {
                changeBtn: "Cambiar",
                removeBtn: "Eliminar"
              },
            
              modal: {
                uploadPhotoTitle: "Subir foto",
                generatePhotoTitle: "Generar foto",
                uploadTab: "Subir",
                generateTab: "Generar",
                dropImageHere: "Arrastra la imagen aquí",
                selectFromComputer: "Seleccionar desde la computadora",
                promptLabel: "Prompt",
                placeholderPrompt: "Ejemplo: Pelo corto y rizado, ojos verdes y una gran sonrisa",
                generateButton: "Generar",
                generating: "Generando...",
                saving: "Guardando...",
                confirmBtn: "Confirmar",
                selectAnotherBtn: "Seleccionar otra",
                removeBtn: "Eliminar Avatar",
                changeBtn: "Cambiar Avatar"
              }
              
            },
            zenitCoinsView: {
              header: {
                title: "Zenit Coins",
                subtitle: "Accede a tu historial de transacciones y agrega más créditos fácilmente a tu cuenta."
              },
              balanceCard: "Saldo disponible: {{count}} Zenit Coins",
              getMoreBtn: "OBTENER MÁS",
              transactions: {
                title: "Transacciones",
                subtitle: "Revisa todas las transacciones de monedas durante el período seleccionado.",
                filterByMonthLabel: "Filtrar por mes",
                selectOption: "Selecciona una opción",
                dec2024: "Diciembre 2024",
                nov2024: "Noviembre 2024",
                viewChartBtn: "Ver Gráfico",
                tableHeader: {
                  date: "Fecha",
                  description: "Descripción",
                  debits: "Débitos",
                  credits: "Créditos",
                  balance: "Saldo"
                }
              },
              chartView: {
                backBtn: "Volver",
                chartTitle: "Análisis de Débitos vs. Saldo"
              }
            },
            subscriptionView: {
              header: {
                title: "Suscripciones",
                subtitle: "Revisa tu suscripción actual y explora planes adicionales."
              },
              currentSubscription: {
                title: "Suscripción Actual",
                plan: "Gratis",
                price: "$0/mes"
              },
              changePlan: {
                title: "Cambiar Plan",
                plans: {
                  free: {
                    name: "Gratis",
                    coins: "100 Zenit Coins / mes",
                    price: "$0/mes",
                    button: "Plan Actual"
                  },
                  professional: {
                    name: "Profesional",
                    coins: "500 Zenit Coins / mes",
                    price: "$20/mes",
                    button: "Cambiar Plan"
                  },
                  enterprise: {
                    name: "Empresa",
                    coins: "Zenit Coins Ilimitadas",
                    button: "Contáctanos"
                  }
                }
              },
              dialog: {
                title: "Contacto",
                fromLabel: "De:",
                placeholderEmail: "Ingresa tu correo",
                placeholderMessage: "Por favor escribe los detalles de tu solicitud, nuestro equipo de soporte te ayudará...",
                cancel: "Cancelar",
                sending: "Enviando...",
                send: "Enviar",
                sentSuccessfully: "Enviado con éxito",
                somethingWentWrong: "Ocurrió un error. Por favor, inténtalo de nuevo."
              }
            },
            supportView: {
              header: {
                title: "Soporte",
                subtitle: "¿Necesitas ayuda? Estamos aquí para asistirte. Por favor llena el formulario y nuestro equipo de soporte te responderá lo antes posible."
              },
              form: {
                fullNameLabel: "Nombre completo",
                discordUsernameLabel: "Usuario de Discord*",
                discordUsernamePlaceholder: "Ej. username",
                discordHelpText: "Debes ser miembro del servidor de Discord para crear un ticket",
                emailLabel: "Correo Electrónico",
                subjectLabel: "Asunto",
                messageLabel: "Mensaje",
                attachmentLabel: "Adjunto (Opcional)",
                fileUploadBtn: "Subir Archivo",
                submitBtn: "Enviar Solicitud",
                submitting: "Enviando...",
                successMessage: "¡Ticket creado con éxito!",
                errorMessage: "Error al crear el ticket. Por favor, inténtalo nuevamente."
              },
              fileAlerts: {
                fileSizeExceeded: "El tamaño del archivo supera el límite de 8MB",
                fileTypeNotSupported: "Tipo de archivo no soportado. Sube imágenes, PDF, DOC, DOCX o archivos TXT."
              }
            },
            footer: {
              brand: {
                labName: "ZENIT AI LAB",
                tagline: "Hablemos",
                email: "contacto@zenitailab.com"
              },
              linksSection: {
                title: "Enlaces",
                whitepaper: "Whitepaper",
                docs: "Documentación",
                pitchDeck: "Pitch Deck"
              },
              legalSection: {
                title: "Legal",
                disclaimer: "Descargo de responsabilidad",
                privacyPolicy: "Política de Privacidad",
                refundPolicy: "Política de Reembolso",
                terms: "Términos y Condiciones"
              },
              socialSection: {
                title: "Social",
                discord: "Discord",
                telegram: "Telegram",
                linkedin: "LinkedIn",
                instagram: "Instagram",
                x: "X"
              },
              copyright:
                "Copyright © {{year}} Zenit AI Lab | Todos los derechos reservados"
            },
            
          }
        }
      },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"]
    }
  });

export default i18n;